<script>
import Cookies from "js-cookie";
import {notificationMethods, courseMethods, uploadMethods} from "@/state/helpers";
import {required} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor';
import appConfig from "@/app.config";
import api from "@/helpers/axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Courses",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast,
    quillEditor,
  },
  data() {
    return {
      imageUrl: "",
      courses: [],
      //
      sites: [],
      educations: [],
      //
      advisors: [],
      products: [],
      //
      level: [],
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      formattedNumber: '',
      items: [],
      quillOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['link'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['clean']
          ]
        }
      },
      currentUser: JSON.parse(Cookies.get('user')),
      title: "Kurslar Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Kurslar",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal: false,
      formError: '',
      editFormError: '',
      addForm: {
        site: [],
        education: "",
        advisor: "",
        //
        name: "",
        shortDescription: "",
        description: "",
        level: [],
        price: 0,
        image: "",
        isActive: true,
      },
      editForm: {
        site: [],
        education: "",
        advisor: "",
        productId: "",
        //
        name: "",
        shortDescription: "",
        description: "",
        level: [],
        price: 0,
        image: "",
        isActive: true,
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label: 'Başlık',
          sortable: true,
        },
        {
          key: "site",
          label: 'Site',
          sortable: true,
        }, {
          key: "education",
          label: 'Eğitim',
          sortable: true,
        },
        {
          key: "level",
          label: 'Kurlar',
          sortable: true,
        },
        {
          key: "detail",
          label: "Detay",
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput: 1
    };
  },
  validations: {
    addForm: {
      name: {required},
      site: {required},
      level: {required},
      education: {required},
      advisor: {required},
      price: {required},
      image: {required},
      description: {required},
      shortDescription: {required},
    },
    editForm: {
      name: {required},
      site: {required},
      level: {required},
      education: {required},
      advisor: {required},
      price: {required},
      image: {required},
      description: {required},
      shortDescription: {required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch: {
    page(newPage) {
      this.pageInput = newPage;
      this.getCourses(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getCourses();
        } else {
          this.page = 1;
        }
      }
    },

    'addForm.email': function () {
      this.addForm.email = this.turkishToLower(this.addForm.email)
    },
    'editForm.email': function () {
      this.editForm.email = this.turkishToLower(this.editForm.email)
    }
  },
  mounted() {
    this.getCourses();
    this.fetchSites();
    this.fetchLevels();
    this.fetchAdvisors();
    this.fetchProducts();
    this.fetchEducations();
  },
  methods: {
    ...courseMethods,
    ...notificationMethods,
    ...uploadMethods,
    resetForm() {
      this.addForm.site = [];
      this.addForm.education = "";
      this.addForm.advisor = "";
      this.addForm.name = null;
      this.addForm.shortDescription = null;
      this.addForm.description = null;
      this.addForm.level = [];
      this.addForm.price = null;
      this.addForm.image = null;
      /*   this.addForm.isActive = null;*/
      //
      this.editForm.site = [];
      this.editForm.education = "";
      this.editForm.advisor = "";
      this.editForm.productId = "";
      this.editForm.name = null;
      this.editForm.shortDescription = null;
      this.editForm.description = null;
      this.editForm.level = [];
      this.editForm.price = null;
      this.editForm.image = null;
      /*     this.editForm.isActive = null;*/

      //
      this.addSubmitted = false;
      this.editSubmitted = false;
    },
    updateImageUrl(url) {
      this.imageUrl = url;
    },
    async fetchLevels() {
      try {
        const response = await api.get("/levels?limit=100");
        this.level = response.data.data.docs;
      } catch (error) {
        return
      }
    },
    toggleLevelSelection(levelId) {
      if (this.addForm.level.includes(levelId)) {
        this.addForm.level = this.addForm.level.filter(id => id !== levelId);
      } else {
        this.addForm.level.push(levelId);
      }
    },

    formatSite(site) {
      return site
    },
    async fetchSites() {
      try {
        const response = await api.get("/sites");
        this.sites = response.data.data.docs;
      } catch (error) {
        return
      }
    },
    async fetchEducations() {
      try {
        const response = await api.get(`/educations`);
        this.educations = response.data.data.docs;
      } catch (error) {
        return error
      }
    },


    async fetchAdvisors() {
      try {
        const response = await api.get("/advisors");
        this.advisors = response.data.data.docs;
      } catch (error) {
        return;
      }
    },
    async fetchProducts() {
      try {
        const response = await api.get("/products?limit=100&section=language");
        this.products = response.data.data.docs;
      } catch (error) {
        return;
      }
    },
    onImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;

      let data = new FormData()
      data.append('upload', files[0])
      data.append('folder', 'courses')
      let addForm = this.addForm;
      this.imgLoading = true;
      this.uploadFile(data).then((res) => {
        addForm.image = res.url;
        this.imgLoading = false;
      })
    },
    onEditImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;
      let data = new FormData()
      data.append('upload', files[0])
      data.append('folder', 'courses')
      let editForm = this.editForm;
      this.editImgLoading = true;

      this.uploadFile(data).then((res) => {
        editForm.image = res.url;
        this.editImgLoading = false;
      })
    },

    doSearch() {
      if (this.page === 1) {
        this.getCourses();
      } else {
        this.page = 1;
      }
    },

    getCourses() {
      this.itemsLoaded = false;
      this.fetchCourses({
        page: this.page,
        limit: this.perPage,
        search: this.search,
        customerUserId: this.customerUserId,
        education: this.education
      })
          .then((res) => {

            this.totalRows = res.total;
            this.items = res.docs;
            if (res.docs && Array.isArray(res.docs)) {
              this.items = res.docs.map(elem => {
                if (elem.level && Array.isArray(elem.level)) {
                  return {
                    ...elem,
                    level: elem.level.map(level => {
                      return {
                        id: level._id,
                        name: level.name,
                      };
                    }),
                  };
                } else {
                  return {
                    ...elem,
                    level: [],
                  };
                }
              });
            } else {
              return
            }
            this.itemsLoaded = true;
          });
    },

    handleSubmit() {
      this.addSubmitted = true;
      this.formError = "";
      this.$v.addForm.$touch();
      if (this.$v.addForm.$invalid) {
        return;
      }
      const courseData = {
        ...this.addForm,
        site: this.addForm.site,
        advisor: this.addForm.advisor,
        education: this.addForm.education,
      };


      this.createCourse(courseData)
          .then(() => {
            this.toastMessage = "Kurs başarıyla eklendi!";
            this.toastAction = "success";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000);
            this.showModal = false;
            this.getCourses();
            this.addForm.name = "";
            this.addForm.shortDescription = "";
            this.addForm.description = "";
            this.education = [];
            this.advisor = [];
            this.addForm.level = [];
            this.addForm.price = "";
            this.addForm.image = "";

          })
          .catch((err) => {
            if (err == 'TCNUMBER_ALREADY_USE') {
              this.formError = "Girilen TC numarasına sahip bir kullanıcı bulunmaktadır.";
            }
            if (err == 'EMAIL_ALREADY_USE') {
              this.formError = "Girilen E-Posta adresine sahip bir kullanıcı bulunmaktadır.";
            } else {
              this.toastMessage = "Sistemde bir hata oluştu!";
              this.toastAction = "error";
              this.showToast = true;
              setTimeout(() => {
                this.showToast = false;
              }, 3000);
            }
          });
    },

    handleEditSubmit() {
      this.editSubmitted = true;
      this.editFormError = "";
      this.$v.editForm.$touch();
      if (this.$v.editForm.$invalid) {
        return;
      }
      this.updateCourse({
        id: this.editId,
        data: {
          ...this.editForm,
          site: this.editForm.site,
          advisor: this.editForm.advisor,
          productId: this.editForm.productId,
          education: this.editForm.education,
        },
      })
          .then(() => {
            this.toastMessage = "Kurs başarıyla düzenlendi!";
            this.toastAction = "success";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000);
            this.editModal = false;
            this.getCourses();
            this.editForm.name = "";
            this.editForm.shortDescription = "";
            this.editForm.description = "";
            this.editForm.education = "";
            this.editForm.advisor = "";
            this.editForm.productId = "";
            this.editForm.level = [];
            this.editForm.price = "";
            this.editForm.image = "";
          })
          .catch((err) => {
            if (err == 'TCNUMBER_ALREADY_USE') {
              this.editFormError = "Girilen TC numarasına sahip bir kullanıcı bulunmaktadır.";
            } else {
              this.toastMessage = "Sistemde bir hata oluştu!";
              this.toastAction = "error";
              this.showToast = true;
              setTimeout(() => {
                this.showToast = false;
              }, 3000);
            }
          });
    },

    handleDeleteSubmit() {
      this.deleteCourse(this.deleteId).then(() => {
        this.deleteModal = false;
        this.toastMessage = "Kurs başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getCourses();
      })
    },

    openEdit(course) {
      this.editId = course.id;
      this.editModal = true;
      this.editForm = {
        name: course.name,
        shortDescription: course.shortDescription,
        description: course.description,
        price: course.price,
        education: course.education._id,
        advisor: course.advisor._id,
        productId: course.productId,
        site: course.site.map(site => site._id),
        level: course.level.map((level) => level.id),
      };


      this.editForm.image = course.image;


      this.updateImageUrl(course.image);

    },

    openDelete(course) {
      if (course.email === this.currentUser.email) {
        this.noDeleteModal = true;
      } else {
        this.deleteId = course.id;
        this.deleteModal = true;
      }
    },
    turkishToLower(str) {
      let letters = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
      str = str.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) {
        return letters[letter];
      })
      return str.toLowerCase();
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  Kurs Ekle
                </button>
              </div>
            </div>
            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                >
                  <template v-slot:cell(createdAt)="data">
                    {{ new Date(data.item.createdAt).toDateString() }}
                  </template>
                  <template v-slot:cell(level)="data">
                    <ul>
                      <li v-for="level in data.item.level" :key="level.id">{{ level.name }}</li>
                    </ul>
                  </template>
                  <template v-slot:cell(site)="data">
                    <ul>
                      <li v-for="site in data.item.site" :key="site.id">{{ site.name }}</li>
                    </ul>
                  </template>
                  <template v-slot:cell(education)="data">
                    {{ formatSite(data.item.education.name) }}
                  </template>
                  <template v-slot:cell(detail)="data">
                    <button
                        class="btn btn-info d-flex py-2"
                        @click="$router.push({name:'courseDetail',params:{courseId: data.item.id}})"
                    >
                      <i :class="`bx bxs-detail bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        :disabled="currentUser.role.includes('user')"
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'50px'}" @keyup.enter="page=pageInput" v-model="pageInput" type="text"
                           class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showModal" title="Kurs Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div
              v-if="formError.length>0"
              class="text-danger d-flex justify-content-end"
          >
            <p>{{ formError }}</p>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Başlık</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Başlık giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Başlık girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label class="me-2" :class="{
                    'is-invalid': addSubmitted && $v.addForm.site.$error,
                  }">Site Seçiniz</label>
                <div class="checkbox-group">
                  <label v-for="site in sites" :key="site.id" class="me-3">
                    <input
                        type="checkbox"
                        :id="`site_${site.id}`"
                        :value="site.id"
                        v-model="addForm.site"
                        class="form-check-input"
                    />
                    <label :for="`site_${site.id}`" class="form-check-label ms-1">{{ site.name }}</label>
                  </label></div>
                <div
                    v-if="addSubmitted && !$v.addForm.site.required"
                    class="invalid-feedback"
                >
                  Site seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <div class="form-group">
                  <label for="education">Eğitim Seçiniz</label>
                  <select id="education" v-model="addForm.education" class="form-control"
                          :class="{
                    'is-invalid': addSubmitted && $v.addForm.education.$error,
                  }"
                  >
                    <option value="">Eğitim Seçiniz</option>
                    <option v-for="education in educations" :key="education.id" :value="education.id">{{
                        education.name
                      }}
                    </option>

                  </select>
                  <div class="invalid-feedback" v-if="addSubmitted && !$v.addForm.education.required">
                    Eğitim seçimi zorunlu bir alandır.
                  </div>

                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label class="me-2" :class="{
                    'is-invalid': addSubmitted && $v.addForm.level.$error,
                  }">Kur Seçiniz</label>
                <div class="checkbox-group">
                  <label v-for="level in level" :key="level.id" class="me-3">
                    <input
                        type="checkbox"
                        :id="`level_${level.id}`"
                        :value="level.id"
                        v-model="addForm.level"
                        :disabled="currentUser.role.includes('user')"
                        class="me-1 mt-1"
                        :class="{
            'is-invalid': addSubmitted && $v.addForm.level.$error,
          }"
                    />
                    <label :for="`level_${level.id}`">{{ level.name }}</label>
                  </label>
                  <div
                      v-if="addSubmitted && !$v.addForm.level.required"
                      class="invalid-feedback"
                  >
                    Kur seçilmesi gerekli bir alandır.
                  </div>
                </div>
                <div
                    v-if="addSubmitted && !$v.addForm.level.required"
                    class="invalid-feedback mb-2" style="margin-top:-10px"
                >
                  Kur seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="advisor">Danışman Seçiniz</label>
                <select id="advisor" v-model="addForm.advisor" class="form-control"
                        :class="{
                    'is-invalid': addSubmitted && $v.addForm.advisor.$error,
                  }">
                  <option value="">Danışman Seçiniz</option>
                  <!-- Loop through the advisors and generate options -->
                  <option v-for="advisor in advisors" :key="advisor.id" :value="advisor.id">{{ advisor.name }}</option>
                </select>
                <div
                    v-if="addSubmitted && !$v.addForm.advisor.required"
                    class="invalid-feedback"
                >
                  Danışman seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="price" class="me-2">Fiyat</label>
                <input  :class="{
                    'is-invalid': addSubmitted && $v.addForm.price.$error,
                  }"
                    id="price"
                    type="text"
                    v-model="addForm.price"
                    class="form-control"
                    placeholder="Fiyat giriniz"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.price.required"
                    class="invalid-feedback"
                >
                  Fiyat girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="description">Kısa Açıklama</label>
                <input
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.shortDescription.$error,
                  }"
                    id="description"
                    type="text"
                    v-model="addForm.shortDescription"
                    class="form-control"
                    placeholder="Kısa Açıklama giriniz"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.shortDescription.required"
                    class="invalid-feedback"
                >
                  Kısa açıklama girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="description"> Açıklama</label>
                <div style="border-radius: 4px"
                     :class="{
    'is-invalid': addSubmitted && $v.addForm.description.$error,
  /*  'border-red': addSubmitted && $v.addForm.description.$error,*/
  }"
                >
                  <quill-editor
                      v-model="addForm.description"
                      ref="quillEditor"
                      :options="quillOptions"
                  ></quill-editor>
                </div>


                <div
                    v-if="addSubmitted && !$v.addForm.description.required"
                    class="invalid-feedback"
                >
                  Açıklama girilmesi gerekli bir alandır.
                </div>
              </div>

            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="image" class="form-label">Detay Resmi</label>
                <input
                    type="file"
                    id="image"
                    @change="onImageChange"
                    accept="image/*"
                    class="form-control"
                    :class="{
                  'is-invalid': addSubmitted && $v.addForm.image.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.image.required"
                    class="invalid-feedback"
                >
                  Resim girilmesi gerekli bir alandır.
                </div>
              </div>

            </div>
            <div
                v-if="formError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ formError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kurs Ekle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="editModal" title="Kurs Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Başlık</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Başlık giriniz"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Başlık girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label class="me-2" :class="{
                    'is-invalid': editSubmitted && $v.editForm.site.$error,
                  }">Site Seçiniz</label>
                <div class="checkbox-group">
                  <label v-for="site in sites" :key="site.id" class="me-3">
                    <input
                        type="checkbox"
                        :id="`site_${site.id}`"
                        :value="site.id"
                        v-model="editForm.site"
                        class="form-check-input"
                    />
                    <label :for="`site_${site.id}`" class="form-check-label ms-1">{{ site.name }}</label>
                  </label></div>
                <div
                    v-if="editSubmitted && !$v.editForm.site.required"
                    class="invalid-feedback"
                >
                  Site seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <div class="form-group">
                  <label for="education">Eğitim Seçiniz</label>
                  <select id="education" v-model="editForm.education" class="form-control"
                          :class="{
                    'is-invalid': editSubmitted && $v.editForm.education.$error,
                  }"
                  >
                    <option value="">Eğitim Seçiniz</option>
                    <option v-for="education in educations" :key="education.id" :value="education.id">{{
                        education.name
                      }}
                    </option>

                  </select>
                  <div class="invalid-feedback" v-if="addSubmitted && !$v.editForm.education.required">
                    Eğitim seçimi zorunlu bir alandır.
                  </div>

                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label class="me-2" :class="{
                    'is-invalid': handleEditSubmit && $v.editForm.level.$error,
                  }">Kur Seçiniz</label>
                <div class="checkbox-group">
                  <label v-for="level in level" :key="level.id" class="me-3">
                    <input
                        type="checkbox"
                        :id="`level_${level.id}`"
                        :value="level.id"
                        v-model="editForm.level"
                        :disabled="currentUser.role.includes('user')"
                        class="me-1 mt-1"
                        :class="{
            'is-invalid': handleEditSubmit && $v.editForm.level.$error,
          }"
                    />
                    <label :for="`level_${level.id}`">{{ level.name }}</label>
                  </label>
                  <div
                      v-if="handleEditSubmit && !$v.editForm.level.required"
                      class="invalid-feedback"
                  >
                    Kur seçilmesi gerekli bir alandır.
                  </div>
                </div>
                <div
                    v-if="handleEditSubmit && !$v.editForm.level.required"
                    class="invalid-feedback mb-2" style="margin-top:-10px"
                >
                  Kur seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="advisor">Danışman Seçiniz</label>
                <select id="advisor" v-model="editForm.advisor" class="form-control"
                        :class="{
                    'is-invalid': editSubmitted && $v.editForm.advisor.$error,
                  }">
                  <option value="">Danışman Seçiniz</option>
                  <!-- Loop through the advisors and generate options -->
                  <option v-for="advisor in advisors" :key="advisor.id" :value="advisor.id">{{ advisor.name }}</option>
                </select>
                <div
                    v-if="editSubmitted && !$v.editForm.advisor.required"
                    class="invalid-feedback"
                >
                  Danışman seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="productId">Bağlı Ürün</label>
                <select id="productId" v-model="editForm.productId" class="form-control">
                  <option value="">Ürün Seçin</option>
                  <!-- Loop through the advisors and generate options -->
                  <option v-for="product in products" :key="product.id" :value="product.id">{{ product.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="price" class="me-2">Fiyat</label>
                <input  :class="{
                    'is-invalid': editSubmitted && $v.editForm.price.$error,
                  }"
                        id="price"
                        type="text"
                        v-model="editForm.price"
                        class="form-control"
                        placeholder="Fiyat giriniz"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.price.required"
                    class="invalid-feedback"
                >
                  Fiyat girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="description">Kısa Açıklama</label>
                <input
                    id="description"
                    type="text"
                    v-model="editForm.shortDescription"
                    class="form-control"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.shortDescription.$error,
                  }"
                    placeholder="Kısa Açıklama giriniz"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.shortDescription.required"
                    class="invalid-feedback"
                >
                 Kısa açıklama girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="description" :class="{
            'is-invalid': editSubmitted && $v.editForm.description.$error,
          }"> Açıklama</label>
                <quill-editor

                    v-model="editForm.description"
                    ref="quillEditor"
                    :options="quillOptions"
                ></quill-editor>
                <div
                    v-if="editSubmitted && !$v.editForm.description.required"
                    class="invalid-feedback"
                >
                  Açıklama girilmesi gerekli bir alandır.
                </div>
              </div>

            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="image" class="form-label">Detay Resmi</label>
                <input
                    :class="{
                  'is-invalid': editSubmitted && $v.editForm.image.$error,
                  }"
                    type="file"
                    id="image"
                    @change="onEditImageChange"
                    accept="image/*"
                    class="form-control"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.image.required"
                    class="invalid-feedback"
                >
                  Resim girilmesi gerekli bir alandır.
                </div>
                <!-- Mevcut resmi göstermek için -->
                <div v-if="editForm.image" class="mt-2 text-center">
                  <img :src="editForm.image" alt="Mevcut Resim" style="max-width: 50%; max-height: 100px;"/>
                </div>
              </div>


            </div>
            <div
                v-if="editFormError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ editFormError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kurs Düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu Kursu silmek istediğinize emin misiniz? Silinmiş Kursu geri alamazsınız.
              </p>
              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız Kursu silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.scrollable {
  max-height: 140px;
  overflow-y: auto;
}

.scrollable::-webkit-scrollbar {
  width: 2px;
}

.scrollable::-webkit-scrollbar-thumb {
  background-color: #6c757d;
  border-radius: 3px;
}

.scrollable::-webkit-scrollbar-thumb:hover {
  background-color: #495057;
}

.scrollable::-webkit-scrollbar-track {
  background-color: #f8f9fa;
}

.pill span {
  padding: 6px 12px 4px 12px;
}

.border-red {
  border: 1px solid #f46a6a;
  border-color: #f46a6a;

  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
</style>
